/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Link, RouteComponentProps, useHistory } from 'react-router-dom';
import { HeaderCategories } from './header-categories';

export default function Header(props: RouteComponentProps) {
  const history = useHistory();
  const [keywords, setKeywords] = useState<string>();
  useEffect(() => {
    adminDashBoard();
  }, []);

  const loginTag = () => {
    if (window.localStorage.getItem('token') === null) {
      return <Link to="/login">로그인</Link>;
    }
    return <Link to="/logout">로그아웃</Link>;
  };

  const signupTag = () => {
    if (window.localStorage.getItem('token') === null) {
      return <Link to="/terms-policies">회원가입</Link>;
    }
    return <div />;
  };

  const logMobileTag = () => {
    if (window.localStorage.getItem('token') === null) {
      return <Link className="login-tag" to="/login" />;
    }
    return <Link className="logout-tag" to="/logout" />;
  };

  const cartTag = () => {
    if (window.localStorage.getItem('token') === null) {
      return <div />;
    }
    return (
      <Link className="shopping-bag" to="/order/cart">
        <span>장바구니</span>
      </Link>
    );
  };

  const orderTag = () => {
    if (window.localStorage.getItem('token') === null) {
      return <div />;
    }
    return (
      <Link className="shipping" to="/order/shipping">
        <span>주문내역조회</span>
      </Link>
    );
  };

  const myPageTag = () => {
    if (window.localStorage.getItem('token') === null) {
      return <div />;
    }
    return (
      <Link className="mypage" to="/mypage">
        <span>마이페이지</span>
      </Link>
    );
  };

  function adminDashBoard() {
    if (
      window.localStorage.getItem('authority') === 'A' ||
      window.localStorage.getItem('part') === 'admin'
    ) {
      return (
        <a href="/admin/dashboard">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
            <path d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z" />
          </svg>
        </a>
      );
    }
    return <div />;
  }

  return (
    <header>
      <nav className="global-menu">
        {loginTag()}
        {signupTag()}

        <Link to="/board/notice">고객센터</Link>
        {adminDashBoard()}
      </nav>
      <div className="wrapper">
        <Link to="/" className="logo" />
        <div className="search">
          <input
            type="search"
            placeholder="도서명 또는 저자를 입력하세요."
            value={keywords || ''}
            onChange={(event) => setKeywords(event.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                history.push({
                  pathname: `/board/search/${keywords}`,
                });
              }
            }}
          />
          <Link to={{ pathname: `/board/search/${keywords}` }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
            </svg>
          </Link>
        </div>
        <div className="quick-links">
          {cartTag()}
          {orderTag()}
          {myPageTag()}
          {logMobileTag()}
        </div>
      </div>

      <HeaderCategories />
    </header>
  );
}
